import Vue from 'vue'
import { AutoComplete } from 'ant-design-vue'
import { savePreviousData } from '@/services/api'
Vue.use(AutoComplete)

export default Vue.extend({
  template: `
    <div class="a-gcell">
      <a-spin :spinning="loading">
        <a-auto-complete 
          class="w-100" 
          size="small" 
          v-model="value" 
          :value="value" 
          :data-source="list" 
          :autoFocus="true" 
          :filter-option="filterOption" 
          @focus="savePreviousData(value)"
          @select="onChange"
        >
        </a-auto-complete>
      </a-spin>
    </div>
    `,

  data() {
    return {
      value: null,
      loading: false,
      savePreviousData: savePreviousData,
      list: [],
    }
  },
  created() {
    this.list = this.params.colDef['cellRendererParams'].dropdownData
    this.value = this.params.value
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      )
    },

    onChange(value) {
      this.value = value.split(' - ')[0]
    },

    getValue() {
      return this.value
    },
  },
})
